import { Drawer, Grid, Stack, Typography } from "@mui/material";
import { gradientBlueBackground } from "themes";
import globeBackground from "assets/images/globeBackground.svg";
import { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";

import Dropzone from "components/shared/Dropzone";
import NewContent from "components/NewContent";

const Dashboard = () => {
  const [files, setFiles] = useState<File[]>([]);
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Stack sx={{ width: "100%", minHeight: "100%" }}>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <CloseIcon
          onClick={() => setDrawerOpen(false)}
          sx={{
            position: "absolute",
            top: 36,
            right: 30,
            cursor: "pointer",
            color: "grey.100",
          }}
        />
        <NewContent setDrawerOpen={setDrawerOpen} files={files} />
      </Drawer>
      <Stack
        sx={{ background: gradientBlueBackground, height: 300, pl: 8, pt: 9 }}
      >
        <Typography
          variant="h4"
          sx={{ color: "background.default", fontWeight: 400 }}
        >
          Welcome to the party
        </Typography>
        <Typography sx={{ color: "grey.100" }}>Pending Content</Typography>
      </Stack>
      <Stack
        sx={{
          mt: -12,
          borderTopRightRadius: 36,
          borderTopLeftRadius: 36,
          backgroundImage: `url("${globeBackground}")`,
          backgroundRepeat: "no-repeat",
          backgroundColor: "background.default",
          height: "100%",
        }}
      >
        <Grid
          container
          sx={{ pl: 50, pt: 20, disaply: "flex", alignItems: "stretch" }}
        >
          <Grid item xs={6}>
            <Stack
              sx={{
                borderBottomStyle: "solid",
                borderBottomWidth: 1,
                borderBottomColor: "#888888",
              }}
            >
              <Typography variant="h4">Make an upload</Typography>
              <Typography variant="h5" sx={{ py: 4 }}>
                To begin translating content, click upload below, or drag and
                drop in you file here.
              </Typography>
            </Stack>
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              width: "100%",
              margin: "0 3rem",
            }}
          >
            <Dropzone 
              Icon={AddIcon} 
              message="Upload New" 
              setFiles={setFiles}
              setIsDrawerOpen={setDrawerOpen}
            />
          </Grid>

          {/* TODO: Add profiles later */}
          {/* <Grid item>
            <Stack>
              <Typography> Pull from another platform</Typography>
              <Typography>
                We support grabbing your content from a multitude of platforms.
              </Typography>
            </Stack>
          </Grid>
          <Grid item>
            <Box>Hook up Profiles</Box>
          </Grid> */}
        </Grid>
      </Stack>
    </Stack>
  );
};

export default Dashboard;
